/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsDeleteSchedule } from "../../funcs/llmEvalsDeleteSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteEvalScheduleRequest$inboundSchema,
};

export const tool$llmEvalsDeleteSchedule: ToolDefinition<typeof args> = {
  name: "llm-evals-delete-schedule",
  description: `Delete an eval schedule

Soft-deletes an eval schedule and removes its Temporal schedule. Historical runs are preserved.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsDeleteSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
